<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import _ from "lodash";
import {RouterLink, useRouter} from "vue-router";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import { useAlertStore } from "@/stores/alertStore";
import { usePageLoadingStore } from "@/stores/pageLoading";
import adminCorpInfoService from "@/pages/admin/services/corporation/adminCorpInfoService";
import MyPageResumeModal from "@/pages/user/components/modal/mypage/MyPageResumeModal.vue";
import KSATextButton from "@/components/ui-components/button/KSATextButton.vue";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
const {$alert, $confirm} = useAlertStore();

const loadingStore = usePageLoadingStore();
const loaded = ref(false);
const router = useRouter()
const { $applyStateGb, $gbNameKR, $number, $pageListBoardNo, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  corporation: {
    type: Object,
    default: () => ({}),
  },
});

const corporation = computed(() => props.corporation || {});
const list = ref([]);

const userMatchingResumeModal = ref(null);  // 이력서 보기

const applyStateGb = ref($applyStateGb);

const applyStateGbsListRef = ref(null);

const searchOpen = ref(true);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

const searchInput = ref({ // 채용 진행 현황 tab 검색조건
  searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
  searchUserName: '',
  searchDurationType: 'all',
  startYmd: '',
  endYmd: '',
});

// 채용 진행 현황 조회
const retrieveList = () => {
  let paramObj = {
    corpId: corporation.value.corpId,
    startYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.startYmd,
    endYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.endYmd,
    searchApplyStateGb: _.map(searchInput.value.searchApplyStateGbs).join(','),
    searchUserName: searchInput.value.searchUserName,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  //loadingStore.loading = true;
  loaded.value = false;
  adminCorpInfoService.retrieveApplicantListPagingByCorpId(paramObj)
      .then( async (res) => {
        loaded.value = true;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    //loadingStore.loading = false;
    loaded.value = true;
  });
}

const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
])

const searchDurationTypeGroup = ref([
  { label:'모든 기간', value: 'all' },
  { label:'기간 검색', value: 'term' },
])

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 검색조건 - 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;

  retrieveList();
}

const clearSearchInput = () => {
  searchInput.value = {
    searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchUserName: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
  }
  applyStateGbsListRef.value.initOptions();
}

const onClickSearch = () => {
  currentPage.value = 1;
  retrieveList();
}

// 이력서 보기
const onClickViewResume = async (resumeId) => {
  userMatchingResumeModal.value.init(false);
  userMatchingResumeModal.value.retrieveApplicantResume(resumeId, 0);
  userMatchingResumeModal.value.show();
}

// 입사지원 상태변경 joinStateGb
const onClickApplyStateGb = async (corpId, resumeId, stateGb) => {
  let modalContent = "";
  let okButtonText = "";
  if (stateGb === "02") {
    modalContent = ["지원취소 처리하시겠습니까?", "'지원취소'으로 상태가 변경됩니다."];
    okButtonText = "지원취소";
  } else if (stateGb === "03") {
    modalContent = ["서류합격 처리하시겠습니까?", "'서류합격'으로 상태가 변경됩니다."];
    okButtonText = "서류합격";
  } else if (stateGb === "04") {
    modalContent = ["서류불합격 처리하시겠습니까?", "'서류불합격'으로 상태가 변경됩니다."];
    okButtonText = "서류불합격";
  } else if (stateGb === "05") {
    modalContent = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
    okButtonText = "최종합격";
  } else if (stateGb === "06") {
    modalContent = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
    okButtonText = "최종불합격";
  }

  const ok = await $confirm(modalContent, okButtonText);

  if(ok) {
    let paramObj = {
      corpId: corpId,
      resumeId: resumeId,
      applyStateGb: stateGb,
    }
    mypageCorpInfoService.updateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert("변경하였습니다.");
            //$toast('', "삭제를 하였습니다.")

            retrieveList();
          } else {
            $alert("변경을 실패하였습니다.");
            console.log(res);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          $alert("변경을 실패하였습니다.");
        });
  }
}

onMounted(()=>{
  retrieveList();
})
</script>
<template>
  <!-- s: 검색 -->
  <div class="filter-wrap" :class="{'open': searchOpen}">
    <p @click="searchOpen = !searchOpen">검색</p>
    <div class="filter">
      <dl>
        <dt style="display:block;">상태</dt>
        <dd>
          <KSACheckBoxGroup
              ref="applyStateGbsListRef"
              className="mr-md"
              name="applyStateGbsList"
              v-model="searchInput.searchApplyStateGbs"
              :options="applyStateGb"
          />
        </dd>
      </dl>
      <dl>
        <dt>입사지원일</dt>
        <dd class="text-box">
          <div class="grid">
            <template v-for="group in searchDurationTypeGroup" key="item.value" >
              <KSARadioButton class="mr-md" name="searchDurationGb3" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
            </template>
            <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
              <KSADatepickerTerms
                  :startDate="searchInput.startYmd"
                  :endDate="searchInput.endYmd"
                  @update:startDate="(value)=> searchInput.startYmd = value"
                  @update:endDate="(value)=> searchInput.endYmd = value"
              />
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>
          이름
        </dt>
        <dd>
          <KSAInput class="text-box" v-model="searchInput.searchUserName" placeholder="이름을 입력해 주세요." />
        </dd>
      </dl>
      <div class="btn-wrap">
        <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
        <KSAPrimaryButton text="검색" @click="onClickSearch" />
      </div>
    </div>
  </div>
  <!-- e: 검색 -->
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>명</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
  </div>

  <div class="table-form">
    <table class="horizontal" v-if="list !== null">
      <tr>
        <th>NO</th>
        <th>이름</th>
        <th>관심 카테고리</th>
        <th>이력서보기</th>
        <th>입사 지원일</th>
        <th>상태</th>
        <th>상태변경</th>
      </tr>
      <tr v-for="corp in list">
        <td>{{ corp.boardNo }}</td>
        <td class="clickable blue">
          <span @click="router.push({name:'MemberDetail', params:{id:corp.userCd}})">{{corp.userName}}</span>
        </td>
        <td>{{ corp.interests }}</td>
        <td class="clickable blue"><span @click="onClickViewResume(corp.resumeId)">이력서 보기</span></td>
        <td>{{ $yyyymmddHHmmss(corp.createDate) }}</td>
        <td>
          <span v-if="corp.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',corp.applyStateGb) }}</span>
          <span v-else-if="corp.applyStateGb === '03' || corp.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',corp.applyStateGb) }}</span>
          <span v-else-if="corp.applyStateGb === '04' || corp.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',corp.applyStateGb) }}</span>
          <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',corp.applyStateGb) }}</span>
        </td>
        <td>
          <div v-if="corp.applyStateGb === '01'">
            <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(corp.corpId, corp.resumeId, '03')"/>
            &nbsp;
            <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(corp.corpId, corp.resumeId, '04')"/>
          </div>
          <div v-else-if="corp.applyStateGb === '03'">
            <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(corp.corpId, corp.resumeId, '05')"/>
            &nbsp;
            <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(corp.corpId, corp.resumeId, '06')"/>
          </div>
          <div v-else>
            -
          </div>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="list.length === 0">
      입사지원 내역이 없습니다.
    </div>
  </div>
  <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
  />
  <MyPageResumeModal ref="userMatchingResumeModal"/>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.clickable {
  text-decoration: underline;
  cursor: pointer;
}
</style>